import { render, staticRenderFns } from "./EntitlementsManagerItem.vue?vue&type=template&id=db36ae7c&scoped=true"
import script from "./EntitlementsManagerItem.vue?vue&type=script&lang=js"
export * from "./EntitlementsManagerItem.vue?vue&type=script&lang=js"
import style0 from "./EntitlementsManagerItem.vue?vue&type=style&index=0&id=db36ae7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db36ae7c",
  null
  
)

export default component.exports